export { renderTagPickerOption_unstable as renderTagPickerOption } from '@fluentui/react-tag-picker';
